export default function TestDocumentDirective() {
  return {
    template: require('./test-document.html'),
    scope: {
      assessmentId: '=',
      testDocument: '=',
      isEditable: '=',
    },
    controller: 'TestDocumentController',
    controllerAs: 'testDocumentVM',
    bindToController: true,
    replace: true,
  };
}
